import utilStyles from '../../../styles/global_ui/util.css';

const PADDING_CLASSES = {
  '3:2': utilStyles.aspectRatioPadding3_2,
  '4:3': utilStyles.aspectRatioPadding4_3,
  '16:9': utilStyles.aspectRatioPadding16_9,
};

export const paddingClassForRatio = (ratio) => PADDING_CLASSES[ratio] || utilStyles.aspectRatioPadding4_3;
